import script from "./VualaVistaView.vue?vue&type=script&setup=true&lang=js"
export * from "./VualaVistaView.vue?vue&type=script&setup=true&lang=js"

import "./VualaVistaView.vue?vue&type=style&index=0&id=70363f6c&lang=css"

const __exports__ = script;

export default __exports__